import script from "./RegisterInfoSupporNumberDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterInfoSupporNumberDialog.vue?vue&type=script&setup=true&lang=js"

import "./RegisterInfoSupporNumberDialog.vue?vue&type=style&index=0&id=dedea92c&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dedea92c"]])

export default __exports__